/**
 * FAQPage JSON-LD — homepage only (separate script; homepage @graph excludes FAQ).
 * Other routes use PageHelmet with faq.js builders.
 */

import React from 'react';
import { Helmet } from 'react-helmet-async';
import { buildHomepageFaqSchema } from '../../content/seo/schema/faq';

export default function FAQJsonLd({ faqs, pageName }) {
  const schema = buildHomepageFaqSchema({ faqs, pageName });
  if (!schema) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
}
